import {request} from "../../../utils/apiUtils";
import {URL_API} from "../../../url.config";

let DiscountAdmissionsRegisterController = {

    create: (payload, callback) => {
        return request({
            url: `${URL_API}/api/sas-school/discount-admissions-register/create`,
            method: 'POST',
            body: {
                ...payload,
            },
        }, callback)
    },
    list: (payload, callback) => {
        return request({
            url: `${URL_API}/api/sas-school/discount-admissions-register/list`,
            method: 'POST',
            body: {
                ...payload,
            },
        }, callback)
    },
    listDiscountRegister: (payload, callback) => {
        return request({
            url: `${URL_API}/api/sas-school/discount-admissions-register/list-discount-register`,
            method: 'POST',
            body: {
                ...payload,
            },
        }, callback)
    },
    edit: (payload, callback) => {
        return request({
            url: `${URL_API}/api/sas-school/discount-admissions-register/edit`,
            method: 'POST',
            body: {
                ...payload,
            },
        }, callback);
    },
    detail: (id, callback) => {
        return request({
            url: `${URL_API}/api/sas-school/discount-admissions-register/detail/${id}`,
            method: 'GET'
        }, callback)
    },
    delete: (id, callback) => {
        return request({
            url: `${URL_API}/api/sas-school/discount-admissions-register/delete/${id}`,
            method: 'GET'
        }, callback)
    }
}

export default DiscountAdmissionsRegisterController
